import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  template: `
    <app-xml-viewer [xml]="xml"></app-xml-viewer>
  `,
  styles: []
})
export class XmlViewerContainerComponent implements OnInit {
  public xml: string = '';

  constructor(
    private dialogConfig: DynamicDialogConfig,
  ) { }

  public ngOnInit(): void {
    this.xml = this.dialogConfig.data?.xml || '';
  }
}

